<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i class="fa" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body no-body-scroll" [hidden]="minimise">
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 36px;"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    @if (!rowData?.COMBINATION_KEY) {
<div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-3 control-label">Entity</label>
        <div class="col-md-6">
          <select class="form-control" [ngModel]="selectedEntity" (ngModelChange)="selectedEntity = $event; onSelectionReady()">
            <option value="">Select Entity</option>
            @for (e of entityDetails; track $index) {
<option [value]="e.ENTITY_DETAILS">{{ e.ENTITY_DETAILS }}</option>
}
          </select>
        </div>
      </div>
      <div class="form-group">
        <label class="col-md-3 control-label">Payor Source</label>
        <div class="col-md-4">
          <select class="form-control" [ngModel]="selectedSource" (ngModelChange)="selectedSource = $event; onSourceChange()">
            <option value="">Select Source</option>
            @for (s of sourceDetails; track $index) {
<option [value]="s.CODE_DESC">{{ s.CODE_DESC }}</option>
}
          </select>
        </div>
      </div>
      @if (lineOptions.length > 0) {
<div class="form-group">
        <label class="col-md-3 control-label">Line Number</label>
        <div class="col-md-2">
          <select class="form-control" [ngModel]="selectedLineNo" (ngModelChange)="selectedLineNo = $event; onSelectionReady()">
            <option value="">Select Line</option>
            @for (l of lineOptions; track $index) {
<option [value]="l">{{ l }}</option>
}
          </select>
        </div>
      </div>
}
      <div class="form-group">
        <label class="col-md-3 control-label">Column</label>
        <div class="col-md-2">
          <select class="form-control" [ngModel]="selectedColumn" (ngModelChange)="selectedColumn = $event; onSelectionReady()">
            <option value="">Select Column</option>
            @for (c of columnList; track $index) {
<option [value]="c">{{ c }}</option>
}
          </select>
        </div>
      </div>
    </div>
}

    @if (cpSubFormList.length > 0) {
<table class="table table-bordered custom-table">
      <thead>
        <tr>
          <th>Select</th>
          <th>Account</th>
          <th>Description</th>
          <th>Book Adj Amt</th>
          <th>Allocated Amt</th>
          <th>Unallocated Amt</th>
        </tr>
      </thead>
      <tbody>
        @for (row of cpSubFormList; track $index) {
<tr>
          <td>
            <input type="radio" [name]="'subrow'" [checked]="selectedSystemAcct === row.ACCOUNT_KEY" (change)="selectSubFormRow(row)">
          </td>
          <td>{{ row.ACCOUNT_VALUE }}</td>
          <td>{{ row.ACCOUNT_DESC }}</td>
          <td>{{ row.BOOK_ADJ_AMT }}</td>
          <td>{{ row.ALLOCATED_AMT }}</td>
          <td>{{ row.UNALLOCATED_AMT }}</td>
        </tr>
}
      </tbody>
    </table>
}

    @if (cpFormRows.length > 0) {
<table class="table table-bordered custom-table">
      <thead>
        <tr>
          @for (c of cpFormColumns; track $index) {
<th>{{ c }}</th>
}
        </tr>
      </thead>
      <tbody>
        @for (row of cpFormRows; track $index) {
<tr>
          @for (c of cpFormColumns; track $index) {
<td>{{ row[c] }}</td>
}
        </tr>
}
      </tbody>
    </table>
}
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" [disabled]="crudLoading || isSaveClicked" (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="reset-button" type="button" (click)="reset()">Reset</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
